const { getObjectValue } = require('@root/helpers');
// const { Swal } = require('sweetalert');

module.exports = {
	getDocuments({ commit, dispatch }, payload = null) {
		let uri = '/api/documents';

		if (payload.type) {
			uri += `/${payload.type.toLowerCase()}`;
		}

		return dispatch(
			'ajaxRequest',
			{
				url: uri,
				params: payload.params,
			},
			{ root: true }
		).then(({ data }) => {
			let name = 'documents.documents';

			commit(
				'SET_VALUE',
				{
					name,
					value: data.documents,
				},
				{ root: true }
			);

			if (getObjectValue('withSubordinates', payload)) {
				name = 'documents.subordinateDocuments';
				commit(
					'SET_VALUE',
					{
						name,
						value: data.subordinateDocuments,
					},
					{ root: true }
				);
			}
		});
	},

	postDocument({ commit }, payload) {
		return axios.post('/api/documents', payload).then(({ data }) => {
			commit(
				'PUSH_ITEM',
				{
					name: `documents.documents`,
					value: data,
				},
				{ root: true }
			);
			return data;
		});
	},

	updateDocument({ commit }, payload) {
		return axios
			.patch(
				`/api/documents/${payload.document_number}`,
				payload.document
			)
			.then(({ data }) => {
				if (getObjectValue('document.customer_id', payload, false)) {
					commit('updateDocumentFields', {
						id: data.id,
						proposal_date: data.proposal_date,
						send_reminder_on: data.send_reminder_on,
						customer_id: data.customer_id,
					});
				}

				commit('updateDocumentFields', {
					id: data.id,
					customer_name: data.customer_name,
					customer_company: data.customer_company,
					customer_address: data.customer_address,
					customer_address2: data.customer_address2,
					customer_zip: data.customer_zip,
					customer_city: data.customer_city,
					customer_state: data.customer_state,
					customer_email: data.customer_email,
					customer_phone: data.customer_phone,
				});

				return data;
			});
	},

	deleteDocument({ commit, rootGetters }, payload) {
		return Vue.swal({
			title: 'Are you sure?',
			text: "You won't be able to revert this!",
			type: 'warning',

			input: 'select',
			inputOptions: {
				price: 'Lost on price',
				delivery: 'Lost on delivery',
				cancelled: 'Project cancelled',
			},
			inputPlaceholder: 'Delete as:',
			inputValidator: (value) => {
				return new Promise((resolve) => {
					if (value) {
						resolve();
					} else {
						resolve('Please select a reason for deleting.)');
					}
				});
			},

			showCancelButton: true,
			confirmButtonText: 'Yes, delete it',
		}).then((result) => {
			if (result.value) {
				return axios
					.delete(`/api/documents/${payload.number}`, {
						params: { reason_for_deleting: result.value },
					})
					.then(({ data }) => {
						let date = Date.now();

						commit(
							'REMOVE_ITEM',
							{
								name: 'documents.documents',
								key: 'id',
								value: payload.id,
							},
							{ root: true }
						);

						commit(
							'REMOVE_ITEM',
							{
								name: 'documents.subordinateDocuments',
								key: 'id',
								value: payload.id,
							},
							{ root: true }
						);

						commit(
							'ADD_NOTIFICATION',
							{
								show: true,
								type: 'success',
								text: 'Document has been deleted',
								id: `document-${payload.id}-deleted-${date}`,
							},
							{ root: true }
						);

						return data;
					});
			}
		});
	},

	orderDocument({ commit }, payload) {
		return axios
			.post(`/api/documents/${payload.document.number}/order`)
			.then(({ data }) => {
				if (data.success) {
					return data;
				}
			});
	},

	sendDocument({ commit, rootState, dispatch, getters }, payload) {
		if(!payload.internal) {
			return Vue.swal({
				title: 'Are you sure?',
				text:
					'By clicking SEND, you will email the Proposal to the Customer associated with this Proposal.',
				type: 'question',
				showCancelButton: true,
				confirmButtonText: 'Send',
				// cancelButtonColor: rootState.theme.error
			}).then((result) => {
				if (result.value) {
					if (
						getObjectValue(
							'for_customer',
							getters.currentDocument(payload.number)
						, false, true) && !getObjectValue(
							'customer_email',
							getters.currentDocument(payload.number)
						)
					) {
						return dispatch('promptForCustomerEmail', payload);
					}
					return dispatch('sendDocumentAjax', payload);
				}
			});
		} else {
			return dispatch('sendDocumentAjax', payload);
		}
	},

	sendDocumentAjax({ commit, rootState, dispatch }, payload) {
		// console.log('in sendDocumentAjax');
		let newPayload = {};

		if(payload.internal) {
			newPayload.internal = payload.internal;
		}

		if (payload.email) {
			newPayload.email = payload.email;
		}

		return axios
			.post(`/api/documents/${payload.number}/send`, newPayload)
			.then(({ data }) => {
				if (data.success) {
					let fields = {
						id: data.document.id,
						delivery_method: data.document.delivery_method,
						saved_at: data.document.saved_at,
						sent_at: data.document.sent_at,
						send_method: data.document.send_method,
						status: data.document.status,
					};

					let date = Date.now();

					if (newPayload.email) {
						fields.customer_email = data.document.customer_email;
					}

					commit('updateDocumentFields', fields);

					commit(
						'ADD_NOTIFICATION',
						{
							show: true,
							type: 'success',
							text: 'Document has been sent',
							id: `document-${data.document.id}-sent-${date}`,
						},
						{ root: true }
					);

					return data;
				}
			})
			.catch((error) => {
				error = Object.assign({}, error);

				if (
					getObjectValue('response.data.errors.email', error, false)
				) {
					return dispatch('promptForCustomerEmail', payload);
				}

				// this.errors.record(error.response.data.errors);
			});
	},

	promptForCustomerEmail({ dispatch }, payload) {
		return Vue.swal({
			title: 'No Customer Email',
			text: 'Please enter an email address to send to.',
			type: 'warning',
			input: 'email',
			inputPlaceholder: 'Email',
			inputValidator: (value) => {
				return new Promise((resolve) => {
					let regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
					if (!value) {
						resolve('Email is required.');
					} else if (!regex.test(value)) {
						resolve('Email is invalid');
					} else {
						resolve();
					}
				});
			},

			showCancelButton: true,
			confirmButtonText: 'Send',
		}).then((result) => {
			if (result.value) {
				payload.email = result.value;

				return dispatch('sendDocumentAjax', payload);
			}

			return;
		});
	},

	saveDocument({ commit, rootState }, payload) {
		return Vue.swal({
			title: 'Are you sure?',
			text:
				'By preforming this action this Quote will no longer be editable.',
			type: 'question',
			showCancelButton: true,
			confirmButtonText: 'Okay',
		}).then((result) => {
			if (result.value) {
				return axios
					.post(`/api/documents/${payload.number}/save`)
					.then(({ data }) => {
						if (data.success) {
							let date = Date.now();

							commit('updateDocumentFields', {
								id: data.document.id,
								delivery_method: data.document.delivery_method,
								saved_at: data.document.saved_at,
								sent_at: data.document.sent_at,
								send_method: data.document.send_method,
								status: data.document.status,
							});

							commit(
								'ADD_NOTIFICATION',
								{
									show: true,
									type: 'success',
									text: 'Document has been saved',
									id: `document-${
										data.document.id
									}-saved-${date}`,
								},
								{ root: true }
							);

							return data;
						}
					});
			}
		});
	},

	updateDocumentStep({ commit, dispatch }, payload) {
		if (payload.document.step < payload.step) {
			return dispatch('updateDocumentField', {
				document_number: payload.document.number,
				field: 'step',
				params: {
					step: payload.step,
				},
			}).then((data) => {
				commit('updateDocumentFields', {
					id: data.document.id,
					step: data.document.step,
				});

				return payload;
			});
		}

		return new Promise((resolve, reject) => {
			resolve(payload);
		});
	},

	updateDocumentField({ commit }, payload) {
		return axios
			.patch(
				`/api/documents/${payload.document_number}/${payload.field}`,
				payload.params
			)
			.then(({ data }) => {
				let params = {
					id: data.document.id,
				};

				params[payload.field] = data.document[payload.field];

				commit('updateDocumentFields', params);

				return data;
			});
	},

	createRevision({ commit }, payload) {
		return axios
			.post(`/api/documents/${payload.document_id}/revision`)
			.then(({ data }) => {
				commit(
					'PUSH_ITEM',
					{
						name: 'documents.documents',
						value: data.new_document,
					},
					{ root: true }
				);

				return data;
			});
	},

	createDuplicate({ commit }, payload) {
		return axios
			.post(`/api/documents/${payload.number}/duplicate`)
			.then(({ data }) => {
				commit(
					'PUSH_ITEM',
					{
						name: 'documents.documents',
						value: data.new_document,
					},
					{ root: true }
				);

				return data;
			});
	},

	postDocumentCustomer({ commit, getters }, payload) {
		return axios
			.post(
				`/api/documents/${payload.document_number}/customer`,
				payload.data
			)
			.then(({ data }) => {
				commit(
					'PUSH_ITEM',
					{
						name: 'quote-builder.customers',
						value: data,
					},
					{ root: true }
				);

				commit('updateDocumentFields', {
					id: getObjectValue(
						'id',
						getters.currentDocument(payload.document_number)
					),
					customer_id: getObjectValue('id', data),
					customer_name: getObjectValue('name', data),
					customer_company: getObjectValue('company', data),
					customer_address: getObjectValue('address', data),
					customer_address2: getObjectValue('address2', data),
					customer_zip: getObjectValue('zip', data),
					customer_city: getObjectValue('city', data),
					customer_state: getObjectValue('state', data),
					customer_email: getObjectValue('email', data),
					customer_phone: getObjectValue('phone', data),
				});

				return data;
			});
	},

	deleteDocumentCustomer({ commit, getters }, payload) {
		//TODO prompt for validation
		return axios
			.delete(`/api/documents/${payload.document_number}/customer`)
			.then(({ data }) => {
				commit('updateDocumentFields', {
					id: getObjectValue(
						'id',
						getters.currentDocument(payload.document_number)
					),
					customer_id: null,
					customer_name: null,
					customer_company: null,
					customer_address: null,
					customer_address2: null,
					customer_zip: null,
					customer_city: null,
					customer_state: null,
					customer_email: null,
					customer_phone: null,
				});
			});
	},
};
